<template>
  <v-container v-if="solution_list">
    <h1>hello data</h1>
    <v-card :color="getColor(index)" v-for = "(task,index) in solution_list" :key="index" style="margin:10px;">
        <v-card-text v-for="(sc,index2) in task.source_codes" :key="index2">
            <h4>{{sc.filename}}</h4>
            <pre>{{sc.filecontent}}</pre>
            <v-btn @click="detail_id =-1">X</v-btn><v-btn @click="getCodeVersions(task.id, task.task_id, task.user_id)">{{task.task_id}} >></v-btn>
            <v-card-text v-if="detail_id == task.id">
                <h1>{{version_count}}</h1>
                <div v-for="(version, index3) in version_list" :key="index3">
                    <h3>{{version.score}} - {{version.time_stamp}}</h3>
                    <pre>{{JSON.parse(version.answer)[0].filecontent}}</pre>
                </div>
                <br>
            </v-card-text>
        </v-card-text>
        <v-card-title>
            <v-layout row wrap>
                <v-flex xs12>
                {{task.name}} {{task.surname}} ({{task.email}}) 
                </v-flex>
                <v-flex xs2>
                    <v-text-field
                        v-model="task.teacher_score"
                        label="Add score by teacher"
                        ></v-text-field>
                </v-flex>
                <v-flex xs1> </v-flex>
                <v-flex xs2>
                    <br/>
                    {{task.score}} -> {{Number.parseInt(task.score) + Number.parseInt(task.teacher_score)}}/{{task.max_score}}
                </v-flex>
                <v-flex xs4>
                        <v-textarea
                            v-model="task.comment"
                            filled
                            flat
                            label="Write comment"
                            outlined
                            :rows="5"                    
                        ></v-textarea>
                        <v-btn @click="saveAll()">Save all</v-btn>
                </v-flex>                
            </v-layout>
        </v-card-title>
    </v-card>

  </v-container>
</template>

<script>
import axios from '../../axios-auth'
// import * as brc from '../../../../../assets/breadcr.js'

export default {
    data() {
        return {
            solution_list : null,
            task_id: 0,
            counter: 0,
            detail_id: -1,
            version_list: [],
            user_competition_id: -1,
            version_count: 0
        }
    },
    mounted() {
        this.initData()
    },
    components: {
    },
    methods: {
      initData() {
        this.$store.commit('setFeedback', null)    
        this.task_id = this.$route.params.id
        axios.get('/get-task-solutions/' + this.task_id, this.$store.getters.getAxiosConfig )
        .then(res => {
            this.solution_list = []
            this.user_competition_id = res.data.ucid
            for (let i = 0; i< res.data.list.length; i++) {
                var sc = ''
                if (res.data.list[i].saved_code.length > 1) 
                 sc = JSON.parse(res.data.list[i].saved_code)
                else sc = '' 
                this.solution_list.push({
                    name : res.data.list[i].name,
                    surname : res.data.list[i].surname,
                    email : res.data.list[i].email,
                    id : res.data.list[i].id,
                    task_id : res.data.list[i].task_id,
                    user_id : res.data.list[i].user_id,
                    score : res.data.list[i].score,
                    teacher_score : res.data.list[i].teacher_score,
                    max_score : res.data.list[i].max_score,
                    comment : res.data.list[i].comment,
                    source_codes: sc
                    })
            }
            /* eslint-disable no-console */
            // console.log(this.solution_list)

        })
        .catch(error => {
            this.$store.commit('setFeedback', error)
        })
      },
      saveAll() {
        var count = 0
        for (let i = 0; i < this.solution_list.length; i++) {
            var ts = this.solution_list[i].teacher_score
            if (isNaN(ts)) ts = 0
            if ((Number.parseInt(ts) + this.solution_list[i].score) > this.solution_list[i].max_score) 
             ts = this.solution_list[i].max_score - this.solution_list[i].score
            const data = {
                id : this.solution_list[i].id,
                teacher_score: ts,
                comment : this.solution_list[i].comment
            }
            axios.post('/write-teacher-comment', data, this.$store.getters.getAxiosConfig )
                .then(() => {
                    // set data to var
                    count = count + 1
                    if (count == this.solution_list.length) this.initData()
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        }
      },
      getCodeVersions(_id, _task_id, _user_id) {
        this.detail_id = -1
        console.log(_task_id, _user_id, this.user_competition_id)
        axios.get('/get-task-versions/' + _task_id+'/'+_user_id+'/'+this.user_competition_id, this.$store.getters.getAxiosConfig )
        .then(res => {            
            this.version_count = res.data.attempts_count
            this.version_list = res.data.attempt_list
            this.detail_id = _id
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)
        })
      },
      getColor(index) {
          if (index % 2 == 0) return "light-blue"
          return "yellow"
      }
      //******************************************************************************* */
    }
}
</script>